import { render, staticRenderFns } from "./FoodForm.vue?vue&type=template&id=a2e0931c&scoped=true"
import script from "./FoodForm.vue?vue&type=script&lang=js"
export * from "./FoodForm.vue?vue&type=script&lang=js"
import style0 from "./FoodForm.vue?vue&type=style&index=0&id=a2e0931c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2e0931c",
  null
  
)

export default component.exports